import { Link } from "react-router-dom";

export const CATEGORY_LABELS = {
  people: "People",
  companies: "Companies",
  brands: "Brands",
  ideas: "Ideas",
  initiatives: "Initiatives",
  specials: "PWM Specials",
  events: "Events",
  news: "News",
  latest: "Latest",
};

export const categoryLabel = (c) => CATEGORY_LABELS[c] || (c || "").replace(/-/g, " ");

const SITE = "https://peoplewhomatter.in";

// Build the BreadcrumbList JSON-LD for a list of {label, to} items (last item is the current page).
export const breadcrumbJsonLd = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.label,
    ...(it.to ? { item: `${SITE}${it.to}` } : {}),
  })),
});

const Breadcrumbs = ({ items, className = "" }) => (
  <nav aria-label="Breadcrumb" className={`text-[11px] md:text-xs text-neutral-500 tracking-wide ${className}`} data-testid="breadcrumbs">
    <ol className="flex items-center gap-1.5 min-w-0 whitespace-nowrap overflow-hidden">
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <li key={`${it.label}-${i}`} className={`flex items-center gap-1.5 min-w-0 ${last ? "flex-1" : "flex-shrink-0"}`}>
            {i > 0 && <span aria-hidden="true" className="text-neutral-300">/</span>}
            {last || !it.to ? (
              <span className="text-neutral-700 truncate" aria-current="page" title={it.label} data-testid="breadcrumb-current">{it.label}</span>
            ) : (
              <Link to={it.to} className="hover:text-neutral-950 transition-colors" data-testid={`breadcrumb-${it.label.toLowerCase().replace(/\s+/g, "-")}`}>{it.label}</Link>
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);

export default Breadcrumbs;
